**Annualized Volatility** measures the annualized variation in daily return of an
index dispersion value. The rolling interval determines the time period used for
calculation for each Volatility value.
